module.exports = __webpack_public_path__ + "static/img/00.898cbca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/00.jpg
// module id = 4pBa
// module chunks = 1